import { Country } from './Types'

export const countries: Country[] = [
	{
		'code': 'AL',
		'name': 'Albania',
		'bounds': {
			'west': 19.2635,
			'south': 39.6448,
			'east': 21.0573,
			'north': 42.6611
		}
	},
	{
		'code': 'AD',
		'name': 'Andorra',
		'bounds': {
			'west': 1.4136,
			'south': 42.4287,
			'east': 1.7867,
			'north': 42.6559
		}
	},
	{
		'code': 'AR',
		'name': 'Argentina',
		'bounds': {
			'west': -73.5604,
			'south': -55.0572,
			'east': -53.6374,
			'north': -21.781
		}
	},
	{
		'code': 'AM',
		'name': 'Armenia',
		'bounds': {
			'west': 43.4474,
			'south': 38.8402,
			'east': 46.6342,
			'north': 41.3011
		}
	},
	{
		'code': 'AW',
		'name': 'Aruba',
		'bounds': {
			'west': -70.0637,
			'south': 12.4118,
			'east': -69.8657,
			'north': 12.6234
		}
	},
	{
		'code': 'AU',
		'name': 'Australia',
		'bounds': {
			'west': 112.9211,
			'south': -54.778,
			'east': 159.1092,
			'north': -9.1422
		}
	},
	{
		'code': 'AT',
		'name': 'Austria',
		'bounds': {
			'west': 9.5307,
			'south': 46.3723,
			'east': 17.1608,
			'north': 49.0205
		}
	},
	{
		'code': 'BH',
		'name': 'Bahrain',
		'bounds': {
			'west': 50.3129,
			'south': 25.5717,
			'east': 50.8245,
			'north': 26.4229
		}
	},
	{
		'code': 'BE',
		'name': 'Belgium',
		'bounds': {
			'west': 2.5454,
			'south': 49.497,
			'east': 6.4081,
			'north': 51.5051
		}
	},
	{
		'code': 'BO',
		'name': 'Bolivia',
		'bounds': {
			'west': -69.6444,
			'south': -22.9004,
			'east': -57.4533,
			'north': -9.6648
		}
	},
	{
		'code': 'BA',
		'name': 'Bosnia and Herzegovina',
		'bounds': {
			'west': 15.7287,
			'south': 42.5555,
			'east': 19.6237,
			'north': 45.2765
		}
	},
	{
		'code': 'BR',
		'name': 'Brazil',
		'bounds': {
			'west': -73.9832,
			'south': -33.7512,
			'east': -28.8478,
			'north': 5.2695
		}
	},
	{
		'code': 'BN',
		'name': 'Brunei',
		'bounds': {
			'west': 114.0759,
			'south': 4.0026,
			'east': 115.3647,
			'north': 5.0459
		}
	},
	{
		'code': 'BG',
		'name': 'Bulgaria',
		'bounds': {
			'west': 22.3572,
			'south': 41.2353,
			'east': 28.6119,
			'north': 44.2155
		}
	},
	{
		'code': 'KH',
		'name': 'Cambodia',
		'bounds': {
			'west': 102.3337,
			'south': 10.3531,
			'east': 107.6277,
			'north': 14.6902
		}
	},
	{
		'code': 'CA',
		'name': 'Canada',
		'bounds': {
			'west': -141.0019,
			'south': 41.6814,
			'east': -52.6194,
			'north': 83.1355
		}
	},
	{
		'code': 'KY',
		'name': 'Cayman Islands',
		'bounds': {
			'west': -81.4202,
			'south': 19.263,
			'east': -79.723,
			'north': 19.7569
		}
	},
	{
		'code': 'CL',
		'name': 'Chile',
		'bounds': {
			'west': -109.4498,
			'south': -55.982,
			'east': -66.4148,
			'north': -17.4986
		}
	},
	{
		'code': 'CN',
		'name': 'China',
		'bounds': {
			'west': 73.4993,
			'south': 7.3643,
			'east': 134.7755,
			'north': 53.561
		}
	},
	{
		'code': 'CO',
		'name': 'Colombia',
		'bounds': {
			'west': -81.7356,
			'south': -4.2273,
			'east': -66.8465,
			'north': 13.3947
		}
	},
	{
		'code': 'CR',
		'name': 'Costa Rica',
		'bounds': {
			'west': -87.102,
			'south': 5.4991,
			'east': -82.5514,
			'north': 11.2197
		}
	},
	{
		'code': 'HR',
		'name': 'Croatia',
		'bounds': {
			'west': 13.4898,
			'south': 42.3922,
			'east': 19.4474,
			'north': 46.555
		}
	},
	{
		'code': 'CY',
		'name': 'Cyprus',
		'bounds': {
			'west': 32.2692,
			'south': 34.6323,
			'east': 34.6066,
			'north': 35.7109
		}
	},
	{
		'code': 'CZ',
		'name': 'Czech Republic',
		'bounds': {
			'west': 12.0906,
			'south': 48.5518,
			'east': 18.8593,
			'north': 51.0557
		}
	},
	{
		'code': 'DK',
		'name': 'Denmark',
		'bounds': {
			'west': 8.0725,
			'south': 54.5591,
			'east': 15.1974,
			'north': 57.7522
		}
	},
	{
		'code': 'DO',
		'name': 'Dominican Republic',
		'bounds': {
			'west': -72.0075,
			'south': 17.4706,
			'east': -68.323,
			'north': 19.932
		}
	},
	{
		'code': 'EC',
		'name': 'Ecuador',
		'bounds': {
			'west': -92.0081,
			'south': -5.0161,
			'east': -75.1944,
			'north': 1.6817
		}
	},
	{
		'code': 'EG',
		'name': 'Egypt',
		'bounds': {
			'west': 24.6968,
			'south': 22,
			'east': 36.8944,
			'north': 31.671
		}
	},
	{
		'code': 'EE',
		'name': 'Estonia',
		'bounds': {
			'west': 21.7643,
			'south': 57.5093,
			'east': 28.21,
			'north': 59.822
		}
	},
	{
		'code': 'FO',
		'name': 'Faroe Islands',
		'bounds': {
			'west': -7.6919,
			'south': 61.3903,
			'east': -6.2536,
			'north': 62.3941
		}
	},
	{
		'code': 'FJ',
		'name': 'Fiji',
		'bounds': {
			'west': 176.8997,
			'south': -21.0425,
			'east': 181.7714,
			'north': -12.4617
		}
	},
	{
		'code': 'FI',
		'name': 'Finland',
		'bounds': {
			'west': 20.5486,
			'south': 59.6761,
			'east': 31.5867,
			'north': 70.0923
		}
	},
	{
		'code': 'FR',
		'name': 'France',
		'bounds': {
			'west': -5.143,
			'south': 41.3333,
			'east': 9.5603,
			'north': 51.0891
		}
	},
	{
		'code': 'DE',
		'name': 'Germany',
		'bounds': {
			'west': 5.8663,
			'south': 47.2701,
			'east': 15.0418,
			'north': 55.0568
		}
	},
	{
		'code': 'GR',
		'name': 'Greece',
		'bounds': {
			'west': 19.3728,
			'south': 34.8006,
			'east': 29.6457,
			'north': 41.7503
		}
	},
	{
		'code': 'GL',
		'name': 'Greenland',
		'bounds': {
			'west': -73.2481,
			'south': 59.7756,
			'east': -11.4833,
			'north': 83.6607
		}
	},
	{
		'code': 'GT',
		'name': 'Guatemala',
		'bounds': {
			'west': -92.2296,
			'south': 13.7402,
			'east': -88.2333,
			'north': 17.8166
		}
	},
	{
		'code': 'GG',
		'name': 'Guernsey',
		'bounds': {
			'west': -2.6751,
			'south': 49.4002,
			'east': -2.1586,
			'north': 49.7328
		}
	},
	{
		'code': 'HK',
		'name': 'Hong Kong',
		'bounds': {
			'west': 113.8351,
			'south': 22.1539,
			'east': 114.4417,
			'north': 22.5619
		}
	},
	{
		'code': 'HU',
		'name': 'Hungary',
		'bounds': {
			'west': 16.1139,
			'south': 45.7371,
			'east': 22.8968,
			'north': 48.5852
		}
	},
	{
		'code': 'IS',
		'name': 'Iceland',
		'bounds': {
			'west': -24.5327,
			'south': 63.2958,
			'east': -13.4946,
			'north': 66.5664
		}
	},
	{
		'code': 'IN',
		'name': 'India',
		'bounds': {
			'west': 68.1745,
			'south': 6.756,
			'east': 97.3954,
			'north': 35.6733
		}
	},
	{
		'code': 'ID',
		'name': 'Indonesia',
		'bounds': {
			'west': 95.0105,
			'south': -11.0097,
			'east': 141.0222,
			'north': 6.0769
		}
	},
	{
		'code': 'IE',
		'name': 'Ireland',
		'bounds': {
			'west': -10.663,
			'south': 51.4199,
			'east': -5.9942,
			'north': 55.4351
		}
	},
	{
		'code': 'IM',
		'name': 'Isle of Man',
		'bounds': {
			'west': -4.8307,
			'south': 54.0431,
			'east': -4.3079,
			'north': 54.4181
		}
	},
	{
		'code': 'IL',
		'name': 'Israel',
		'bounds': {
			'west': 34.2676,
			'south': 29.4956,
			'east': 35.8962,
			'north': 33.3328
		}
	},
	{
		'code': 'IT',
		'name': 'Italy',
		'bounds': {
			'west': 6.6268,
			'south': 35.4929,
			'east': 18.5204,
			'north': 47.0921
		}
	},
	{
		'code': 'JM',
		'name': 'Jamaica',
		'bounds': {
			'west': -78.3688,
			'south': 17.7058,
			'east': -76.1829,
			'north': 18.525
		}
	},
	{
		'code': 'JP',
		'name': 'Japan',
		'bounds': {
			'west': 122.9338,
			'south': 24.0457,
			'east': 145.8175,
			'north': 45.523
		}
	},
	{
		'code': 'KZ',
		'name': 'Kazakhstan',
		'bounds': {
			'west': 46.4937,
			'south': 40.5687,
			'east': 87.3154,
			'north': 55.442
		}
	},
	{
		'code': 'KE',
		'name': 'Kenya',
		'bounds': {
			'west': 33.9098,
			'south': -4.6913,
			'east': 41.9069,
			'north': 5.0334
		}
	},
	{
		'code': 'XK',
		'name': 'Kosovo',
		'bounds': {
			'west': 20.0143,
			'south': 41.8576,
			'east': 21.7899,
			'north': 43.2677
		}
	},
	{
		'code': 'KW',
		'name': 'Kuwait',
		'bounds': {
			'west': 46.553,
			'south': 28.5244,
			'east': 48.7781,
			'north': 30.1037
		}
	},
	{
		'code': 'LV',
		'name': 'Latvia',
		'bounds': {
			'west': 20.9706,
			'south': 55.6747,
			'east': 28.2415,
			'north': 58.0856
		}
	},
	{
		'code': 'LB',
		'name': 'Lebanon',
		'bounds': {
			'west': 35.1036,
			'south': 33.055,
			'east': 36.6237,
			'north': 34.6921
		}
	},
	{
		'code': 'LY',
		'name': 'Libya',
		'bounds': {
			'west': 9.3915,
			'south': 19.5,
			'east': 25.1496,
			'north': 33.1665
		}
	},
	{
		'code': 'LT',
		'name': 'Lithuania',
		'bounds': {
			'west': 20.954,
			'south': 53.8968,
			'east': 26.8355,
			'north': 56.4504
		}
	},
	{
		'code': 'LU',
		'name': 'Luxembourg',
		'bounds': {
			'west': 5.7357,
			'south': 49.4479,
			'east': 6.531,
			'north': 50.1828
		}
	},
	{
		'code': 'MO',
		'name': 'Macau',
		'bounds': {
			'west': 113.5287,
			'south': 22.1098,
			'east': 113.5983,
			'north': 22.2171
		}
	},
	{
		'code': 'MG',
		'name': 'Madagascar',
		'bounds': {
			'west': 43.1885,
			'south': -25.6062,
			'east': 50.4861,
			'north': -11.9488
		}
	},
	{
		'code': 'MY',
		'name': 'Malaysia',
		'bounds': {
			'west': 99.6407,
			'south': 0.8539,
			'east': 119.2697,
			'north': 7.3806
		}
	},
	{
		'code': 'MV',
		'name': 'Maldives',
		'bounds': {
			'west': 72.6385,
			'south': -0.7037,
			'east': 73.7597,
			'north': 7.1063
		}
	},
	{
		'code': 'MU',
		'name': 'Mauritius',
		'bounds': {
			'west': 56.5853,
			'south': -20.5255,
			'east': 63.5033,
			'north': -10.3372
		}
	},
	{
		'code': 'MX',
		'name': 'Mexico',
		'bounds': {
			'west': -118.3651,
			'south': 14.53,
			'east': -86.7104,
			'north': 32.7187
		}
	},
	{
		'code': 'MN',
		'name': 'Mongolia',
		'bounds': {
			'west': 87.7345,
			'south': 41.5818,
			'east': 119.9315,
			'north': 52.1484
		}
	},
	{
		'code': 'MA',
		'name': 'Morocco',
		'bounds': {
			'west': -13.1671,
			'south': 27.6705,
			'east': -0.997,
			'north': 35.9222
		}
	},
	{
		'code': 'NA',
		'name': 'Namibia',
		'bounds': {
			'west': 11.7366,
			'south': -28.9706,
			'east': 25.2618,
			'north': -16.9635
		}
	},
	{
		'code': 'NL',
		'name': 'Netherlands',
		'bounds': {
			'west': 3.3584,
			'south': 50.7504,
			'east': 7.2275,
			'north': 53.555
		}
	},
	{
		'code': 'NZ',
		'name': 'New Zealand',
		'bounds': {
			'west': 165.87,
			'south': -52.6088,
			'east': 183.8456,
			'north': -34.1296
		}
	},
	{
		'code': 'NG',
		'name': 'Nigeria',
		'bounds': {
			'west': 2.6636,
			'south': 4.2707,
			'east': 14.678,
			'north': 13.8856
		}
	},
	{
		'code': 'MK',
		'name': 'North Macedonia',
		'bounds': {
			'west': 20.4533,
			'south': 40.8539,
			'east': 23.034,
			'north': 42.3736
		}
	},
	{
		'code': 'NO',
		'name': 'Norway',
		'bounds': {
			'west': 4.4999,
			'south': 57.9594,
			'east': 31.1683,
			'north': 71.1855
		}
	},
	{
		'code': 'OM',
		'name': 'Oman',
		'bounds': {
			'west': 52,
			'south': 16.6501,
			'east': 59.8398,
			'north': 26.4049
		}
	},
	{
		'code': 'PK',
		'name': 'Pakistan',
		'bounds': {
			'west': 60.873,
			'south': 23.7046,
			'east': 77.1204,
			'north': 37.0914
		}
	},
	{
		'code': 'PA',
		'name': 'Panama',
		'bounds': {
			'west': -83.0516,
			'south': 7.2038,
			'east': -77.1394,
			'north': 9.6457
		}
	},
	{
		'code': 'PE',
		'name': 'Peru',
		'bounds': {
			'west': -81.3282,
			'south': -18.3517,
			'east': -68.6521,
			'north': -0.0389
		}
	},
	{
		'code': 'PH',
		'name': 'Philippines',
		'bounds': {
			'west': 114.2779,
			'south': 4.5873,
			'east': 126.6049,
			'north': 21.1219
		}
	},
	{
		'code': 'PL',
		'name': 'Poland',
		'bounds': {
			'west': 14.1229,
			'south': 49.002,
			'east': 24.1459,
			'north': 54.8358
		}
	},
	{
		'code': 'PT',
		'name': 'Portugal',
		'bounds': {
			'west': -31.269,
			'south': 30.0288,
			'east': -6.1892,
			'north': 42.1543
		}
	},
	{
		'code': 'PR',
		'name': 'Puerto Rico',
		'bounds': {
			'west': -67.9514,
			'south': 17.8814,
			'east': -65.2211,
			'north': 18.516
		}
	},
	{
		'code': 'QA',
		'name': 'Qatar',
		'bounds': {
			'west': 50.7501,
			'south': 24.4711,
			'east': 51.6608,
			'north': 26.1835
		}
	},
	{
		'code': 'RO',
		'name': 'Romania',
		'bounds': {
			'west': 20.2618,
			'south': 43.6194,
			'east': 29.7153,
			'north': 48.2656
		}
	},
	{
		'code': 'SM',
		'name': 'San Marino',
		'bounds': {
			'west': 12.4033,
			'south': 43.8936,
			'east': 12.5162,
			'north': 43.9921
		}
	},
	{
		'code': 'SA',
		'name': 'Saudi Arabia',
		'bounds': {
			'west': 34.4953,
			'south': 16.3795,
			'east': 55.6667,
			'north': 32.1543
		}
	},
	{
		'code': 'RS',
		'name': 'Serbia',
		'bounds': {
			'west': 18.839,
			'south': 42.2315,
			'east': 23.0064,
			'north': 46.1901
		}
	},
	{
		'code': 'SC',
		'name': 'Seychelles',
		'bounds': {
			'west': 46.2029,
			'south': -10.2271,
			'east': 56.2947,
			'north': -3.7129
		}
	},
	{
		'code': 'SG',
		'name': 'Singapore',
		'bounds': {
			'west': 103.6057,
			'south': 1.1587,
			'east': 104.0885,
			'north': 1.4709
		}
	},
	{
		'code': 'SK',
		'name': 'Slovakia',
		'bounds': {
			'west': 16.8332,
			'south': 47.7312,
			'east': 22.5657,
			'north': 49.6138
		}
	},
	{
		'code': 'SI',
		'name': 'Slovenia',
		'bounds': {
			'west': 13.3755,
			'south': 45.4214,
			'east': 16.5974,
			'north': 46.8767
		}
	},
	{
		'code': 'ZA',
		'name': 'South Africa',
		'bounds': {
			'west': 16.4546,
			'south': -34.8342,
			'east': 32.8911,
			'north': -22.1254
		}
	},
	{
		'code': 'KR',
		'name': 'South Korea',
		'bounds': {
			'west': 124.6098,
			'south': 33.1128,
			'east': 131.8728,
			'north': 38.6172
		}
	},
	{
		'code': 'ES',
		'name': 'Spain',
		'bounds': {
			'west': -18.1612,
			'south': 27.6377,
			'east': 4.3278,
			'north': 43.7924
		}
	},
	{
		'code': 'LK',
		'name': 'Sri Lanka',
		'bounds': {
			'west': 79.5213,
			'south': 5.9187,
			'east': 81.879,
			'north': 9.836
		}
	},
	{
		'code': 'SE',
		'name': 'Sweden',
		'bounds': {
			'west': 10.9577,
			'south': 55.3367,
			'east': 24.1761,
			'north': 69.06
		}
	},
	{
		'code': 'CH',
		'name': 'Switzerland',
		'bounds': {
			'west': 5.9559,
			'south': 45.818,
			'east': 10.4922,
			'north': 47.8085
		}
	},
	{
		'code': 'TW',
		'name': 'Taiwan',
		'bounds': {
			'west': 114.3593,
			'south': 10.3713,
			'east': 122.1091,
			'north': 26.3853
		}
	},
	{
		'code': 'TH',
		'name': 'Thailand',
		'bounds': {
			'west': 97.3434,
			'south': 5.6129,
			'east': 105.6368,
			'north': 20.4651
		}
	},
	{
		'code': 'TT',
		'name': 'Trinidad and Tobago',
		'bounds': {
			'west': -61.9309,
			'south': 10.0425,
			'east': -60.4925,
			'north': 11.3588
		}
	},
	{
		'code': 'TR',
		'name': 'Turkey',
		'bounds': {
			'west': 25.6652,
			'south': 35.8122,
			'east': 44.8181,
			'north': 42.1049
		}
	},
	{
		'code': 'UA',
		'name': 'Ukraine',
		'bounds': {
			'west': 22.1371,
			'south': 44.3866,
			'east': 40.2256,
			'north': 52.3794
		}
	},
	{
		'code': 'AE',
		'name': 'United Arab Emirates',
		'bounds': {
			'west': 51.498,
			'south': 22.6315,
			'east': 56.3816,
			'north': 26.0694
		}
	},
	{
		'code': 'GB',
		'name': 'United Kingdom',
		'bounds': {
			'west': -8.6501,
			'south': 49.8668,
			'east': 1.763,
			'north': 60.8608
		}
	},
	{
		'code': 'US',
		'name': 'United States',
		'bounds': {
			'west': -187.5552,
			'south': 18.9107,
			'east': -66.9496,
			'north': 71.3885
		}
	},
	{
		'code': 'UY',
		'name': 'Uruguay',
		'bounds': {
			'west': -58.4914,
			'south': -34.9735,
			'east': -53.1014,
			'north': -30.0853
		}
	},
	{
		'code': 'VE',
		'name': 'Venezuela',
		'bounds': {
			'west': -73.3529,
			'south': 0.6469,
			'east': -59.8065,
			'north': 12.4912
		}
	},
	{
		'code': 'VN',
		'name': 'Vietnam',
		'bounds': {
			'west': 102.1439,
			'south': 7.6024,
			'east': 116.6811,
			'north': 23.3927
		}
	}
]
